import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '@app/utils/constants/regex.constants';

export const ROLE_NAME_MIN_LENGTH = 2;
export const ROLE_NAME_MAX_LENGTH = 50;
export const ROLE_DESCRIPTION_MAX_LENGTH = 500;

const ROLE_NAME_PATTERN = REGEX.roleName;
const ROLE_DESCRIPTION_PATTERN = REGEX.roleDescription;

export const roleNameFormatValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = (control.value ?? '') as string;

  if (!value) {
    return null;
  }

  const isInvalid =
    value.trim() !== value ||
    value.length < ROLE_NAME_MIN_LENGTH ||
    value.length > ROLE_NAME_MAX_LENGTH ||
    !ROLE_NAME_PATTERN.test(value);

  return isInvalid ? { invalidRoleName: true } : null;
};

export const roleNameValidator = roleNameFormatValidator;
export const roleDescriptionFormatValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = (control.value ?? '') as string;

  if (!value) {
    return null;
  }

  const isInvalid =
    value.length > ROLE_DESCRIPTION_MAX_LENGTH ||
    value.trim() !== value ||
    !ROLE_DESCRIPTION_PATTERN.test(value);

  return isInvalid ? { invalidRoleDescription: true } : null;
};

export const roleDescriptionValidator = roleDescriptionFormatValidator;
export const roleNameDuplicateValidator = (
  existingNames: string[],
  currentName: string | null,
): ValidatorFn => {
  const normalizedExisting = existingNames.filter(Boolean).map((name) => name.trim().toLowerCase());

  const normalizedCurrent = currentName?.trim().toLowerCase() ?? null;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '') as string;

    if (!value) {
      return null;
    }

    const normalizedValue = value.trim().toLowerCase();

    if (normalizedCurrent && normalizedValue === normalizedCurrent) {
      return null;
    }

    const exists = normalizedExisting.includes(normalizedValue);

    return exists ? { roleNameExists: true } : null;
  };
};

export const atLeastOnePermissionSelectedValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value as Record<string, boolean> | null;

  if (!value || Object.keys(value).length === 0) {
    return { noPermissionSelected: true };
  }

  const hasAtLeastOneSelected = Object.values(value).some(Boolean);

  return hasAtLeastOneSelected ? null : { noPermissionSelected: true };
};
